// extracted by mini-css-extract-plugin
module.exports = {"title":"registration-final_title__50Qxp","buttonWrap":"registration-final_buttonWrap__1-eGb"};